import HeroSectionSlider from '@/containers/landingPage/HeroSectionSlider';
import { Box, Button, Flex, Link } from '@chakra-ui/react';
import React from 'react';
import Calendar from './Calendar';
import FeatureInfo from './featureSection/FeatureInfo';
import FeatureMap from './featureSection/FeatureMap';
import HomeDemoTestimonial from './HomeDemoTestimonial';
import MembersTabs from './MembersTabs';
import PartnerEvents from './PartnerEvents';

const slides = [
  {
    id: 2,
    title: 'IVCA CAT III Submit 2025 ',
    desc: '6th August 2025 | Mumbai ',
    showBtn: false,
    buttons: {
      text: 'Learn More',
      url: '',
    },
    banner: {
      lg: 'https://static.levocdn.com/WGLBUT82/WhatsAppImage2025-07-23at41335PM-w9fQsJuVshrQ1.jpg',
    },
  },
  {
    id: 3,
    title: 'IVCA Secondaries Conference 2025 ',
    desc: '21th August 2025 | Mumbai ',
    showBtn: false,
    buttons: {
      text: 'Learn More',
      url: '',
    },
    banner: {
      lg: 'https://static.levocdn.com/WGLBUT82/WhatsAppImage2025-07-23at41320PM-EBhkLxBkMZDKM.jpg',
    },
  },

  {
    id: 1,
    title: 'IVCA Climate & Sustainability Council Initiatives',
    desc: 'Mobilizing Capital for a Sustainable India. ',
    showBtn: true,
    buttons: {
      text: 'Learn More',
      url: 'https://www.ivca.in/climate-and-sustainability-council',
    },
    banner: {
      lg: 'https://static.levocdn.com/WGLBUT82/Rectangle4339-XZbabFT67YnR.svg',
      md: 'https://static.levocdn.com/WGLBUT82/Bannerformobile2-UpLgWyVqhyPC.svg',
    },
  },

  {
    id: 2,
    title: 'Welcome to IVCA',
    desc: 'Indian Venture and Alternate Capital Association (IVCA) is a not-for-profit, apex industry body promoting the alternate capital industry and fostering a vibrant investing ecosystem in India.',
    showBtn: true,
    buttons: { text: 'About Us', url: '/about-us' },
    banner: { lg: '/webp/homeSlideOne.webp' },
  },

  {
    id: 4,
    title: 'SEBI AI Simplification',
    desc: 'SEBI AI Simplification of Requirements',
    showBtn: true,
    buttons: { text: 'Read More', url: '/sebiupdates/accredited-investor' },
    banner: {
      lg: 'https://static.levocdn.com/WGLBUT82/7130124319659207262.png',
    },
  },
  {
    id: 5,
    title: 'Regulatory Reporting - SEBI',
    desc: 'Regulatory Reporting by AIFs - Circular Issued by SEBI',
    showBtn: true,
    buttons: {
      text: 'Read More',
      url: '/sebiupdates/sebi-quarterly-reporting-by-aifs',
    },
    banner: { lg: '/webp/citySkyline.webp' },
  },
];

const HomePage: React.FunctionComponent = () => (
  <>
    <HeroSectionSlider slides={slides} />
    <FeatureInfo />
    <FeatureMap />
    <Calendar />
    <PartnerEvents />
    <MembersTabs />
    <HomeDemoTestimonial />
  </>
);

export default HomePage;
